export const VIDEO_ACTION_TYPES = {
    LIST_VIDEOS: "VIDEO_LIST_VIDEOS",
    LIST_VIDEOS_REQUEST: "VIDEO_LIST_VIDEOS_REQUEST",
    LIST_VIDEOS_FAILURE: "VIDEO_LIST_VIDEOS_FAILURE",
    
    CHANGE_FILTER_DATE: "CHANGE_FILTER_DATE",
    SELECT_BRAIN: "SELECT_BRAIN",
    SET_IS_CONVERTING: "SET_IS_CONVERTING",
};